module.exports = __webpack_public_path__ + "img/email.b1a5720c.svg";